import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import LockReset from '../../../common/components/icons/LockReset';

const useStyles = makeStyles((theme) => ({
  resetButton: {
    color: theme.palette.error.main,
  },
}));

interface Props {
  open: boolean;
  pending: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const ResetMfaDialog: React.FC<Props> = ({
  open,
  pending,
  onCancel,
  onConfirm,
}) => {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      data-cy="userSetup_resetMfaDialog"
    >
      <DialogTitle>Reset MFA Enrollment?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Resetting this user's MFA enrollment will require them to set up MFA again on their device.
          This action cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant="text"
          className={classes.resetButton}
          endIcon={<LockReset />}
          onClick={onConfirm}
          disabled={pending}
          data-cy="userSetup_resetMfaConfirmButton"
        >
          Reset MFA
        </Button>
        <Button
          variant="text"
          onClick={onCancel}
          disabled={pending}
          data-cy="userSetup_resetMfaCancelButton"
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ResetMfaDialog;
